/*
Object with default remote config.
For default config before response or for typization
@key name of experiment (variable in remote config)
@value {String} value of variable – type string.
Use JSON.stringify for values!
*/
import { isProdBuildMode } from '#shared/helpers/buildMode';

export type TExperiment = {
  experiment_id: number;
  group_id: number;
  value: any;
  enabled: boolean;
};

export type TParameter = TExperiment | boolean; // Feature flag is Boolean

export const defaultConfig: { [key: string]: string } = {
  show_quick_shop_button: JSON.stringify({ experiment_id: 1, group_id: 1, enabled: false }),
  product_buy_button: JSON.stringify({ group_id: 2, experiment_id: 15, enabled: false }),
  product_badge_installment: JSON.stringify({ group_id: 2, experiment_id: 14, enabled: false }),
  product_badge_description: JSON.stringify({ group_id: 2, experiment_id: 13, enabled: false }),
  max_price_category: JSON.stringify({ group_id: 2, experiment_id: 12, enabled: false }),
  checkout_payment_methods: JSON.stringify({ experiment_id: 9, group_id: 1, enabled: true }),
  empty_suggests: JSON.stringify({ group_id: 1, experiment_id: 7, enabled: true }),
  new_main: 'false',
  new_product_page: 'false',
  checkout_non_acceptance_payment: 'false',
  search_timer: JSON.stringify({ enabled: true }),
  pdp_payment_dolyame: JSON.stringify({ experiment_id: 16, group_id: 1, enabled: true }),
  pdp_marketing_banner_enabled_web: 'false',
  sber_promo: 'true',
  new_rates: 'false',
  notification_popup: JSON.stringify({ enabled: isProdBuildMode() }),
} as const;
